import React from 'react';
import { landImage } from '../../data/home';
import { ArrowButton } from '../ui/ArrowButton';
export function LandSale() {
  return <section className="w-full bg-white pb-24" data-id="element-120" data-mp="x3x494fp5cw">
      <div className="mx-auto max-w-[1320px] px-6" data-id="element-121" data-mp="ex4z5rwfqity">
        <div className="relative overflow-hidden rounded-[32px] bg-ink" data-id="element-122" data-mp="ewltb9k27kwa">
          <img src={landImage} alt="" className="absolute inset-0 h-full w-full object-cover opacity-60" data-id="element-123" data-mp="awux2qbrkckd" />
          <div className="absolute inset-0 bg-ink/40" aria-hidden="true" data-id="element-124" data-mp="3jcek37lucyqz" />
          <div className="relative flex min-h-[420px] flex-col justify-end p-8 md:p-14" data-id="element-125" data-mp="3ed1w2jj8hlmt">
            <span className="w-fit rounded-full bg-signal px-3 py-1 text-[12px] font-bold uppercase tracking-wide text-white" data-id="element-126" data-mp="3s4gi6z8fu2y3">
              Nouveau
            </span>
            <h2 className="font-display mt-5 max-w-2xl text-[52px] text-white md:text-[80px]" data-id="element-127" data-mp="3nb3xv1askib5">Vente de terrains</h2>
            <div className="mt-5 flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-128" data-mp="2vm0ox87ymjs6">
              <p className="max-w-md text-[16px] leading-relaxed text-white/80" data-id="element-129" data-mp="3qk1d47a02ekp">
                Chinguitty Bank met en vente des lots viabilisés à Nouakchott. Consultez les parcelles disponibles et
                les modalités d’acquisition.
              </p>
              <ArrowButton to="/vente-de-terrains" variant="light" data-id="element-130" data-mp="458kfk9cegod">
                Voir les terrains
              </ArrowButton>
            </div>
          </div>
        </div>
      </div>
    </section>;
}